<template>
  <div
    class="select-box flex align-center justify-center"
    @click="handleClick()"
    :class="[{ selected: isSelected }, focused ? 'select-box-focused' : '']"
  >
    <input type="checkbox" class="anchor-tab" ref="anchorRef" />
    <slot></slot>
  </div>
</template>

<script setup>
// eslint-disable-next-line
import { defineProps, computed, ref, onMounted } from 'vue';

const emit = defineEmits(['update:modelValue', 'click']);
const focused = ref(false);
const anchorRef = ref({});
const props = defineProps({
  modelValue: null,
  value: null,
  multiple: {
    type: Boolean,
    default: false,
  },
  customSelectedClass: {
    type: Boolean,
    default: false,
    required: false,
  },
  customCssClass: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const handleClick = () => {
  let valueUpdate = props.value;
  if (props.multiple) {
    valueUpdate = !props.modelValue;
  }
  emit('update:modelValue', valueUpdate);
  emit('click');
};

onMounted(() => {
  window.addEventListener('keyup', (e) => {
    if (document.activeElement === anchorRef.value) {
      focused.value = true;
    } else {
      focused.value = false;
    }

    if (document.activeElement === anchorRef.value && e.keyCode === 13) {
      handleClick();
    }
  });
});

const isSelected = computed(() => {
  if (props.customSelectedClass) return false;
  if (props.multiple) {
    return props.value;
  }
  return props.modelValue === props.value;
});
</script>
